<template>
  <div>
    <div v-if="item.editorType == 'Relate'">
      <RelateComponent
        v-model="fieldValue"
        :rRoute="item.editorOptions.relateModule"
        :fieldName="item.dataField"
        :disabled="item.editorOptions.disabled"
        :pRoute="routeDef"
        :slug="prefix"
        v-on:changed="inputChanged()"
      >
      </RelateComponent>
    </div>

    <!-- Custom Relate Field -->
    <div v-if="item.editorType == 'customRelateField'">
      <CustomRelateCompo
        v-model="fieldValue"
        :rRoute="item.editorOptions.relateModule"
        :fieldName="item.dataField"
        :disabled="item.editorOptions.disabled"
        :pRoute="routeDef"
        :slug="prefix"
        v-on:changed="inputChanged()"
        v-on:itemSelected="onRelateItemSelected"
      >
      </CustomRelateCompo>
    </div>

    <div v-if="item.editorType == 'Phone'">
      <DxNumberBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>

    <div v-if="item.editorType == 'MultiSelect'">
      <MultiSelectComponent
        v-model="fieldValue"
        :datasource="item.editorOptions.dataSource"
        :pRoute="routeDef"
        :slug="prefix"
      >
      </MultiSelectComponent>
    </div>

    <div v-if="item.editorType == 'dxTextBox'">
      <DxTextBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>
    <div v-if="item.editorType == 'dxNumberBox'">
      <DxNumberBox
        v-model="fieldValue"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>
    <!-- dxDateBox -->
    <div v-if="item.editorType == 'dxDateBox'">
      <DxDateBox
        v-model="fieldValue"
        :display-format="item.editorOptions.displayFormat"
        :type="item.editorOptions.type"
        :value="currentDate"
        :disabled="item.editorOptions.disabled"
        @focus-out="onDateFocusOut"
        value-change-event="keyup"
        @value-changed="inputChanged()"
      />
    </div>

    <div v-if="item.editorType == 'userstamp'">
      <UserStampComponent
        v-model="fieldValue"
        :rRoute="item.editorOptions.relateModule"
        :fieldName="item.dataField"
        :disabled="item.editorOptions.disabled"
        :pRoute="routeDef"
        :slug="prefix"
        v-on:changed="inputChanged()"
      >
      </UserStampComponent>
    </div>

    <!-- dxSelectBox -->
    <div v-if="item.editorType == 'dxSelectBox'">
      <DxSelectBox
        v-model="fieldValue"
        :data-source="item.editorOptions.dataSource"
        :display-expr="item.editorOptions.displayExpr || 'text'"
        :value-expr="item.editorOptions.valueExpr || 'value'"
        :placeholder="item.editorOptions.placeholder"
        :search-enabled="item.editorOptions.searchEnabled || false"
        :disabled="item.editorOptions.disabled"
        @value-changed="onSelectBoxValueChanged"
      />
    </div>

    <div v-if="item.editorType == 'ConnectedField'">
      <DxSelectBox
        v-model="fieldValue"
        :data-source="item.editorOptions.dataSource"
        :display-expr="item.editorOptions.displayExpr || 'text'"
        :value-expr="item.editorOptions.valueExpr || 'value'"
        :placeholder="item.editorOptions.placeholder"
        :search-enabled="item.editorOptions.searchEnabled || false"
        :disabled="item.editorOptions.disabled"
        @value-changed="onSelectBoxValueChanged"
      />
    </div>
    <div v-if="item.editorType == 'SelectBoxWithIcon'">
      <DxSelectBox
        v-model="fieldValue"
        :data-source="iconOptions"
        :display-expr="'text'"
        :value-expr="'value'"
        :placeholder="'Select an icon'"
        :search-enabled="true"
        :disabled="item.editorOptions?.disabled"
        @value-changed="onSelectBoxValueChanged"
      >
        <template #item="{ data }">
          <div class="icon-select-item">
            <img :src="data.iconPath" :alt="data.text" class="icon-preview" />
            <span class="icon-text">{{ data.text }}</span>
          </div>
        </template>
        <template #dropDownButtonTemplate>
          <div class="custom-dropdown-button">
            <i class="icon-dropdown"></i>
          </div>
        </template>
      </DxSelectBox>
    </div>

    <!-- New UploadFile component -->
    <!-- Updated UploadFile component section -->
      <div v-if="item.editorType == 'UploadFile'">
      <div class="file-upload-container">
        <div class="upload-section">
          <DxFileUploader
            :multiple="item.editorOptions.allowMultiple === '1'"
            :accept="item.editorOptions.accept"
            upload-mode="useForm"
            :show-file-list="false"
            @value-changed="onFileValueChanged"
            :disabled="item.editorOptions?.disabled"
            :label-text="getLabelText()"
            select-button-text="Browse"

          />
       
          <div
            v-if="uploadError"
            class="error-message"
            style="color: red; margin-top: 5px"
          >
            {{ uploadError }}
          </div>
          <div
            v-if="!uploadError && item.editorOptions?.maxFileSize"
            class="file-size-limit"
          >
            Maximum file size: {{ item.editorOptions.maxFileSize }}
            {{ item.editorOptions.sizeUnit || "KB" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxTextBox from "devextreme-vue/text-box";
import DxNumberBox from "devextreme-vue/number-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import DxFileUploader from "devextreme-vue/file-uploader";
import DropDataGrid from "./DropDataGrid.vue";
import RelateComponent from "./RelateComponent.vue";
import CustomRelateCompo from "./CustomRelateCompo.vue";
import UserStampComponent from "./UserStampComponent.vue";
import MultiSelectComponent from "./MultiSelectComponent.vue";
import DxSelectBox from "devextreme-vue/select-box";
import { ref } from "vue";
const now = new Date();

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from "devextreme-vue/form";
import MultiSelectComponentVue from "./MultiSelectComponent.vue";

export default {
  props: {
    modelValue: String,
    defaultDate: Boolean,
    item: {
      type: Object,
      default: () => ({}),
    },
    prefix: String,
    routeDef: String,
    field: Object,
    model: Object,
    viewType: String,
    createDef: Array,
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    DropDataGrid,
    DxSimpleItem,
    UserStampComponent,
    DxTextBox,
    DxNumberBox,
    DxDateBox,
    DxSelectBox,
    DxFileUploader,
    DxButton,
    RelateComponent,
    CustomRelateCompo,
    MultiSelectComponent,
  },
  data: function () {
    return {
      uploadedFileName: ref(""),
      fileSize: ref(""),
      uploadError: ref(""),
      fieldValue: this.modelValue,
      selectedLedgerId: "12234",
      currentDate: null,
      relateSelectedItem: null,
      imagePreview: null,
      uploadedFileName: "",
      items: this.createDef,
      fileSize: "",
      filepathField: "",
      iconOptions: [
        {
          value: "user.png",
          text: "user",
          iconPath: "/images/icons/user.png",
        },
        {
          value: "ic_home.svg",
          text: "ic_home",
          iconPath: "/images/icons/ic_home.svg",
        },
      ],
    };
  },
  methods: {
    // New method to get a display name for the file
    getFileDisplayName() {
      // First check for explicitly uploaded file
      if (this.uploadedFileName) {
        return this.uploadedFileName;
      }

      // Check model value for file information
      if (this.modelValue) {
        if (typeof this.modelValue === "object" && this.modelValue.name) {
          return this.modelValue.name;
        }
        if (typeof this.modelValue === "string" && this.modelValue.trim()) {
          // Extract filename from path if it's a path
          if (this.modelValue.includes("/")) {
            return this.modelValue.split("/").pop();
          }
          return this.modelValue;
        }
      }

      // Check for filename in the field definition
      if (this.item && this.item.filename) {
        return this.item.filename;
      }

      // If we have createDef, try to find the field there
      if (this.createDef) {
        const def = Array.isArray(this.createDef)
          ? this.createDef
          : this.createDef.value || [];

        for (const group of def) {
          if (group && group.items && Array.isArray(group.items)) {
            const matchingField = group.items.find(
              (f) =>
                f.dataField === this.item.dataField &&
                f.editorType === "UploadFile"
            );

            if (matchingField && matchingField.filename) {
              console.log(matchingField.filename);
              return matchingField.filename;
            }
          }
        }
      }

      // Return null if no filename was found so v-if can hide the element
      return null;
    },

    getLabelText() {
      // For the label text inside the uploader component
      if (this.getFileDisplayName()) {
        // If we have a filename, use generic "Change file" text for the button
        return this.getFileDisplayName();
      }

      // If no file is selected, use generic "Select file" text
      return "Select file";
    },

    onFileValueChanged(e) {
      this.uploadError = "";
      const file = e.value?.[0];

      if (!file) {
        this.uploadedFileName = "";
        this.fileSize = "";
        this.$emit("update:modelValue", null);
        return;
      }

      // File type validation
      if (this.item.editorOptions.accept) {
        const acceptedTypes = this.item.editorOptions.accept
          .split(",")
          .map((type) => type.trim().toLowerCase());

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type.toLowerCase();

        // Check if file type/extension matches any accepted type
        const isValidType = acceptedTypes.some((type) => {
          console.log(
            fileExtension ||
              (type.includes("/") && file.type.startsWith(type.split("/")[1]))
          );
          return (
            type === fileExtension ||
            (type.includes("/") && file.type.startsWith(type.split("/")[0]))
          );
        });

        if (!isValidType) {
          this.uploadError = `File type not allowed. Allowed types: ${this.item.editorOptions.accept}`;
          this.uploadedFileName = "";
          this.fileSize = "";
          return;
        }
      }

      // File size validation
      if (this.item.editorOptions?.maxFileSize) {
        const maxSize = this.getMaxFileSizeInBytes();

        if (file.size > maxSize) {
          this.uploadError = `File size exceeds the maximum allowed size of ${
            this.item.editorOptions.maxFileSize
          } ${this.item.editorOptions.sizeUnit || "KB"}`;
          this.uploadedFileName = "";
          this.fileSize = "";
          return;
        }
      }

      // If all validations pass
      this.uploadedFileName = file.name;
      this.fileSize = this.formatFileSize(file.size);
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result;

        // For image files, set the preview
        if (file.type.startsWith("image/")) {
          this.imagePreview = base64String;
        }

        // Emit the file data object with both the file and base64 data
        const fileData = {
          file: file,
          name: file.name,
          size: file.size,
          type: file.type,
          content: true,
        };

        // Update the model value with the file data
        this.fieldValue = fileData;
        this.$emit("update:modelValue", fileData);

        // Emit a specific event for file uploads
        this.$emit("onFileUploaded", fileData);
      };

      reader.onerror = () => {
        this.uploadError = "Error reading file";
      };

      // Read the file as a data URL (base64)
      reader.readAsDataURL(file);
    },

    // Helper method to convert size to bytes based on unit
    getMaxFileSizeInBytes() {
      const size = Number(this.item.editorOptions.maxFileSize);
      const unit = this.item.editorOptions.sizeUnit || "KB";

      switch (unit.toUpperCase()) {
        case "B":
          return size;
        case "KB":
          return size * 1024;
        case "MB":
          return size * 1024 * 1024;
        case "GB":
          return size * 1024 * 1024 * 1024;
        default:
          return size * 1024; // Default to KB
      }
    },

    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + " B";
      else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
      else return (bytes / 1048576).toFixed(1) + " MB";
    },

    clearError() {
      this.uploadError = null;
    },

    removeImage() {
      this.imagePreview = null;
      this.uploadedFileName = "";
      this.fileSize = "";
      this.fieldValue = null;
      this.uploadError = null;
      this.$emit("update:modelValue", null);
      this.$emit("onFileRemoved");
    },

    onSelectBoxValueChanged(e) {
      console.log("SelectBoxWithIcon value changed:", e.value);
      this.$emit("update:modelValue", e.value);

      // Find the selected icon data and emit it
      const selectedIcon = this.iconOptions.find(
        (icon) => icon.value === e.value
      );
      this.$emit("onIconSelected", selectedIcon);
    },
    onRelateItemSelected(item) {
      // Store both ID and name
      this.relateSelectedItem = item;

      // Emit the complete item data to parent with additional field name info
      const fieldData = {
        id: item.id,
        name: item.name,
        fieldName: this.item.dataField,
      };

      // Emit to parent
      this.$emit("update:value", fieldData);
      this.$emit("onRelateItemSelected", fieldData);
    },

    inputChanged(e) {
      // For non-relate fields, just emit the value
      if (this.item.editorType !== "Relate") {
        this.$emit("update:modelValue", e ? e.value : this.fieldValue);
      }
    },
    checkValue() {
      console.log(" checkValue CheckBox", this.checkboxValue);
    },

    updateCheckboxValue(value) {
      // Update the checkboxValue when ComponentOne emits the event
      this.checkboxValue = value;
      console.log("updateCheckboxValue value", value);
    },
    onDateFocusOut(e) {
      var dateInputValue = e.event.target.value;

      console.log("onDateFocusOut dateInputValue", dateInputValue);
      if (dateInputValue === "") {
        console.log("onDateFocusOut Inside", dateInputValue);

        if (this.item.dataField != "transaction_date") {
          dateInputValue = null;
          this.$emit("update:modelValue", dateInputValue);
        }
      }
    },
    onSelectBoxValueChanged(e) {
      console.log("SelectBox value changed:", e.value);
      this.$emit("update:modelValue", e.value);

      // Emit a custom event for select box changes if needed
      this.$emit("onSelectBoxValueChanged", e.value);
    },
  },
  mounted() {
    // Watch for changes in the fieldValue
    this.$watch("fieldValue", (newVal) => {
      this.$emit("update:modelValue", newVal);
    });

    // Set default date if needed
    if (
      this.item.editorType == "dxDateBox" &&
      this.item.editorOptions.type == "date" &&
      this.defaultDate
    ) {
      this.currentDate = new Date();

      // Format the date consistently just like in your watcher
      const formattedDate = this.currentDate
        .toLocaleDateString("en-IN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/\//g, "-");

      // Update the fieldValue which will trigger the watcher
      this.fieldValue = formattedDate;

      // Also emit directly to ensure it's propagated
      this.$emit("update:modelValue", formattedDate);

      // Emit transaction date changed event if it's a transaction date field
      if (this.item.dataField == "transaction_date") {
        this.$emit("onTransactionDateChanged", formattedDate);
      }
    }

    // Check if there's already a value for the file upload
 
    this.$watch("fieldValue", (newVal, oldVal) => {
      console.log("fieldValue changed called", newVal);
      if (
        this.item.editorType == "dxDateBox" &&
        this.item.editorOptions.type == "date" &&
        newVal instanceof Date &&
        newVal != null
      ) {
        console.log("new DateBox val", newVal);
        newVal.setHours(6, 0, 0, 0);

        const formattedDate = newVal
          .toLocaleDateString("en-IN", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/\//g, "-");

        console.log("update:modelValue formattedDate val", formattedDate);
        this.$emit("update:modelValue", formattedDate);

        if (this.item.dataField == "transaction_date") {
          this.$emit("onTransactionDateChanged", formattedDate);
          console.log("transaction detail series", formattedDate);
        }
      }

      if (this.item.editorType == "customRelateField") {
        this.$emit("onCustomRelateValueChanged", newVal);
        this.$emit("update:modelValue", newVal);
      }
      if (this.item.editorType == "Relate") {
        this.$emit("onRelateValueChanged", newVal);
        this.$emit("update:modelValue", newVal);
      } else {
        console.log("dsd val", newVal);
        this.$emit("update:modelValue", newVal);

        if (this.item.dataField == "transaction_date") {
          this.$emit("onTransactionDateChanged", newVal);

          console.log("Edit  transaction detail series", newVal);
        }
      }
    });
  },
};
</script>

<style scoped>
.icon-select-item {
  display: flex;
  align-items: center;
  padding: 8px 5px;
}
.icon-preview {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  object-fit: contain;
}
.icon-text {
  font-size: 14px;
}
.custom-dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.icon-dropdown {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #6c757d;
}

/* File upload styling */

 .file-upload-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 10px;
}

.upload-section {
  flex: 1;
  max-width: 300px;
}

.upload-error {
  margin-top: 5px;
  color: #d9534f;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(217, 83, 79, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
}

.clear-error-button {
  padding: 0;
  margin-left: 5px;
  min-width: 16px;
  height: 16px;
}

.image-preview-container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.preview-image {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  object-fit: cover;
  background-color: #f9f9f9;
}

.image-info {
  font-size: 11px;
  margin-top: 3px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remove-button {
  position: absolute;
  top: -8px;
  right: -8px;
  border-radius: 50%;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d9534f;
  border: none;
  font-size: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.file-info-display {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.file-icon {
  margin-right: 8px;
}

.file-name {
  flex-grow: 1;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download-link {
  margin-left: 8px;
  color: #007bff;
  text-decoration: none;
}
.custom-file-label {
  margin-bottom: 5px;
  padding: 6px 10px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.file-info-display {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.file-icon {
  margin-right: 8px;
}

.file-name {
  flex-grow: 1;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  color: #6c757d;
  margin-left: 5px;
  font-size: 12px;
}

.remove-file-btn {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  margin-left: 8px;
  padding: 2px 5px;
}

.remove-file-btn:hover {
  background-color: #f8d7da;
  border-radius: 3px;
}


</style>